module.exports = __webpack_public_path__ + "img/07.fc68191a.png";